import './Rrn.scss'

import {BlockType, Blocks} from '../blocks/Blocks'
import {Hero, HeroType} from '../layout/Hero'
import React, {useState} from 'react'

import {BoxBlock} from '../blocks/BoxBlock'
import {Breadcrumbs} from '../layout/Breadcrumbs'
import {FormStepType} from '../blocks/FormBlock'
import {Layout} from '../layout/Layout'
import {PageData} from '../../types'
import {Theme} from '../Theme'
import box from '../webshop/pages/cart/orderform/fields/box'
import city from '../webshop/pages/cart/orderform/fields/city'
import emailField from '../evenementen/layout/EditionRegistration/fields/emailField'
import firstNameField from '../evenementen/layout/EditionRegistration/fields/firstNameField'
import {formatBelgianNationalNumberPartial} from '../../util/formatBelgianNationalNumberPartial'
import houseNumber from '../webshop/pages/cart/orderform/fields/houseNumber'
import lastNameField from '../evenementen/layout/EditionRegistration/fields/lastNameField'
import phoneField from '../evenementen/layout/MemberRegistration/fields/phoneField'
import streetField from '../evenementen/layout/EditionRegistration/fields/streetField'
import {style} from '../../util/style'
import {wrap} from '@codeurs/front'
import zip from '../webshop/pages/cart/orderform/fields/zip'

const styles = style('rrn', [
	'form',
	'advantage',
	'messagecounter',
	'error',
	'thanks'
])

type RrnFormType = {
	reCaptchaKey: string
	user: {
		hash: string
		segment: 'a' | 'b'
		fname: string
		lname: string
		street: string
		number: string
		box: string
		zip: string
		city: string
		email: string
		phone: string
		rrn: string
	}
}

export type RrnType = {
	hero: HeroType
	blocks?: Array<BlockType>
	errorData?: {
		title: string
		text: string
	}
} & RrnFormType

export const Rrn: React.FC<PageData & RrnType> = wrap(Layout)(({...props}) => {
	const {parents, title, hero, reCaptchaKey, user, errorData} = props

	return (
		<div className={styles()}>
			<Hero {...hero} title={(hero && hero.title) || title} />
			<Breadcrumbs parents={parents} title={title} />
			{errorData ? (
				<Theme.Container>
					<Error title={errorData.title} text={errorData.text} />
				</Theme.Container>
			) : null}

			{!errorData ? <RrnForm reCaptchaKey={reCaptchaKey} user={user} /> : null}
		</div>
	)
})

const Error: React.FC<RrnType['errorData']> = ({title, text}) => (
	<div className={styles.error()}>
		<BoxBlock title={title} text={text} />
	</div>
)

const getSteps = (segment: 'a' | 'b', hash: string): Array<FormStepType> => [
	{
		id: 1,
		parent_id: 0,
		channel: 'step',
		label: '',
		submit_text: 'Mijn gegevens opslaan',
		sections: [
			{
				id: 1,
				parent_id: 1,
				channel: 'section',
				label: '',
				fields: [
					!hash
						? {
								id: 0,
								parent_id: 1,
								channel: 'input',
								name: 'pvkey',
								label: 'Pvkey',
								required: true,
								type: 'number',
								placeholder: ''
						  }
						: null,
					{...firstNameField, id: 1, parent_id: 1},
					{...lastNameField, id: 2, parent_id: 1},
					{...streetField, id: 3, parent_id: 1},
					{...houseNumber, id: 4, parent_id: 1},
					{...box, id: 5, parent_id: 1},
					{...zip, id: 6, parent_id: 1},
					{...city, id: 7, parent_id: 1},
					segment === 'b'
						? {...emailField, id: 8, parent_id: 1, mod: 'half', required: false}
						: null,
					segment === 'b'
						? {...phoneField, id: 9, parent_id: 1, required: false}
						: null,
					{
						id: 10,
						parent_id: 1,
						channel: 'input',
						name: 'rrn',
						label: 'Rijksregisternummer',
						required: true,
						type: 'text',
						placeholder: '',
						pattern: '[0-9]{2}.[0-9]{2}.[0-9]{2}-[0-9]{3}.[0-9]{2}',
						minLength: 15,
						maxLength: 15
					}
				]
			}
		]
	}
]

type ThanksResponse = {
	thanks: string
}

const Thanks: React.FC<ThanksResponse> = ({thanks}) => (
	<div className={styles.thanks()}>
		<Theme.Container>
			<BoxBlock markedtitle={''} title={'Bedankt'} text={thanks} />
		</Theme.Container>
	</div>
)

const RrnForm: React.FC<RrnFormType> = ({reCaptchaKey, user}) => {
	const [response, setResponse] = useState<ThanksResponse | null>(null)
	const [data, setData] = useState<{[key: string]: any}>({
		hash: user['hash'],
		segment: user['segment'],
		'1-1-1': user['fname'],
		'1-1-2': user['lname'],
		'1-1-3': user['street'],
		'1-1-4': user['number'],
		'1-1-5': user['box'],
		'1-1-6': user['zip'],
		'1-1-7': user['city'],
		'1-1-8': user['email'],
		'1-1-9': user['phone'],
		'1-1-10': user['rrn']
	})

	if (response) return <Thanks {...response} />

	const steps: Array<FormStepType> = getSteps(user['segment'], user['hash'])

	const onChangeHandler = (key, value) => {
		switch (key) {
			case '1-1-10':
				setData({
					...data,
					'1-1-10': formatBelgianNationalNumberPartial(value)
				})
				break
			default:
				setData({...data, [key]: value})
		}
	}

	return (
		<div className={styles.form()}>
			<Theme.Container>
				<Blocks
					blocks={[
						{
							type: 'form' as 'form',
							path: '',
							requestUri: window.location.pathname,
							reCaptchaKey,
							id: 1,
							pageId: 0,
							steps,
							data,
							onChange: onChangeHandler,
							useEffect: true,
							onSubmit: setResponse
						}
					]}
				/>
			</Theme.Container>
		</div>
	)
}
